module.exports = __webpack_public_path__ + "static/media/3.9887d7d4.png";